import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AddressLookup } from '../../models/address-lookup';
import { BaseApiService } from './base-api.service';
import { FileDataInput } from '../../models/fileDataInput';
import { FileUploadArea } from '../enums/FileUploadArea';
import { FileUpload } from '../../models/fileUpload';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  constructor(private _baseService: BaseApiService) {  }

  getAllForProperty(propertyId : string): Observable<FileUpload[]> {
    const url = `/api/file/all-for-area`;
    let data : Partial<FileDataInput> = {
      lookupKey: propertyId,
      area: FileUploadArea.Property
    };
    return this._baseService.post<FileUpload[]>(url, data);
  }

  deleteImage(imageId : number): Observable<boolean> {
    const url = `/api/file/${imageId}`;
    let data : Partial<FileDataInput> = {
      id: imageId,
      area: FileUploadArea.Property
    };
    return this._baseService.delete<boolean>(url);
  }

  upload(fileUpload : FileUpload): Observable<boolean> {

    if(fileUpload.area === undefined || fileUpload.lookupKey === undefined) {
      throw new Error('FileUpload must have area and lookupKey set');
    }
    const url = `/api/file/upload/${fileUpload.area}/${fileUpload.lookupKey}`;
    let data : Partial<FileUpload> = fileUpload;
    return this._baseService.post<boolean>(url, data);
  }

  uploadFormData(formData: FormData): Observable<boolean> {

    if (!formData.has('area') || !formData.has('lookupKey')) {
      throw new Error('FileUpload must have area and lookupKey set');
    }

    const url = `/api/file/upload/${formData.get('area')}/${formData.get('lookupKey')}`;
    // const headers = new HttpHeaders();
    // const headers = new HttpHeaders({
    // 'Content-Type': 'multipart/form-data'
    // });
    return this._baseService.post<boolean>(url, formData);
  }

  
  updateSortOrders(fileUploads : FileUpload[], lookupKey:number): Observable<boolean> {
    const url = `/api/file/multiple`;
    var multipleFiles = {
      Files : fileUploads,
      area : FileUploadArea.Property,
      lookupKey : fileUploads[0].lookupKey
    };
    return this._baseService.put<boolean>(url, multipleFiles);
  }
}
